import { invoke } from '../AppServices';

const stripePayment = async (data) => {
  const response = await invoke({ id: 'createIntent', paramValue: data });
  return response;
};

export const handleCardActionResponse = async (data) => {
  const response = await invoke({ id: 'confirmPayment', paramValue: data });
  return response;
};

export const stripePaymentMethodHandler = async (data, callback) => {
  const { amount, result, description } = data;

  if (result.error) {
    callback(result);
  } else {
    const paymentResponse = await stripePayment({
      payment_method_id: result.paymentMethod.id,
      name: result.paymentMethod.billing_details.name,
      email: result.paymentMethod.billing_details.email,
      amount,
      description,
    });

    callback(paymentResponse);
  }
};
